// extracted by mini-css-extract-plugin
module.exports = {"root":"MyProductItem_root__3nKZS","imgContainer":"MyProductItem_imgContainer__3wPk9","staticOverlay":"MyProductItem_staticOverlay__1q373"};